<template>
  <div v-if="!loader">
    <div v-if="canEnterCode && !timerHasExpired">
      <alert-label
        :closable=false
        textAlign="center"
        color="none"
        >Введите код подтверждения
      </alert-label>
    </div>
    <div>
      <verification-code-input
        ref="verificationCodeInput"
        v-show="canEnterCode && !timerHasExpired"
        :codeLength="codeLength"
        v-on:input="onVerifyCodeInput"
        v-on:complete="onVerifyCodeInputComplete"
      />
      <ErrorAlert v-if="!canEnterCode && !timerHasExpired" message="Превышено допустимое количество попыток ввода кода" />
      <ErrorAlert v-if="!canEnterCode && timerHasExpired" message="Код недействителен или уже был использован" />
      <ErrorAlert v-if="timerHasExpired" message="Время ожидания вышло" />
      <!-- <alert-label
        v-if="!canEnterCode && !timerHasExpired"
        :closable=false
        color="red">Превышено допустимое количество попыток ввода кода
      </alert-label>
      <alert-label
        v-if="!canEnterCode && timerHasExpired"
        :closable=false
        color="red">Код недействителен или уже был использован
      </alert-label>
      <alert-label
        v-if="timerHasExpired"
        :closable=false
        textAlign="center"
        color="red">Время ожидания вышло
      </alert-label> -->
    </div>
    <div v-if="canEnterCode && !timerHasExpired && showPasswordField && verifyCode.length === verifyCodeLength">
      <!-- <gb-label size='mini' class="loginFormLabel">Новый пароль</gb-label> -->
      <input id="reset-password-field" :minlength="minPasswordLength" placeholder='Новый пароль*' class="input-strong full-width" type="password" v-model="password"/>
      <span v-if="password && password.length > 0" @click="showHidePassword" title="Показать/скрыть пароль" id="toggle-password" toggle="#reset-password-field" class="fa fa-fw fa-eye field-icon toggle-password"></span>
      <!-- <gb-message size='mini' style="font-style: italic" class="loginFormLabel unselectable" :message="`минимальная длина пароля: ${minPasswordLength} символов`"></gb-message> -->
      <alert-label
        :closable=false
        fontSize="0.9em"
        color="none"><i>минимальная длина пароля: {{minPasswordLength}} символов</i>
      </alert-label>
    </div>
    <div>
      <button
        v-if="canEnterCode && !timerHasExpired && isCompleteForm"
        class="btn"
        :fullWidth="true"
        @click="sendConfirmationCode()">Продолжить</button>
    </div>
    <alert-label
      v-if="timerEnabled && !loader"
      :closable=false
      textAlign="center"
      color="none">Запросить код повторно через {{ timerText }}
    </alert-label>
    <div v-if="timerHasExpired">
      <button
        class="btn"
        :disabled="loader"
        :fullWidth="true"
        @click="requestNewVerifyCode()">Запросить код повторно</button>
    </div>
  </div>
</template>

<script>
import AlertLabel from '../alert-label.vue';
import VerificationCodeInput from './verification-code-input';

export default {
  components: {
    VerificationCodeInput,
    AlertLabel,
  },
  props: {
    showPasswordField: {
      type: Boolean,
      default: false,
    },
    minPasswordLength: {
      type: Number,
      default: 6,
    },
    canEnterCode: {
      type: Boolean,
      default: true,
    },
    lifetimeSeconds: {
      type: Number,
      default: 60,
    },
    verifyCodeLength: {
      type: Number,
      default: 6,
    },
    loader: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timerEnabled: false,
      downTimeSeconds: 0,
      downTimeMinute: 1,
      timerHasExpired: false,
      timerText: '',
      confirmResetCode: false,
      timer: null,
      stopTime: new Date(),
      resetPasswRequest: null,
      confirmationCodeLength: 0,
      verifyCode: {
        type: String,
        default: '',
      },
      password: {
        type: String,
        default: '',
      },
    };
  },
  computed: {
    isCompleteForm() {
      return this.canEnterCode && this.verifyCode.length === this.verifyCodeLength &&
        (!this.showPasswordField || this.password.length >= this.minPasswordLength);
    },
    codeLength() {
      return this.loader ? 0 : this.verifyCodeLength;
    },
  },
  watch: {
    loader(oldValue, newValue) {
      if (oldValue !== newValue && newValue === true) {
        this.startTimer(this.lifetimeSeconds);
      }
    },
  },
  methods: {
    checkTime(i) {
      return i < 10 ? `0${i}` : i;
    },
    onVerifyCodeInput(value) {
      if (value) this.verifyCode = value;
      else this.verifyCode = '';
    },
    onVerifyCodeInputComplete() {
      if (this.showPasswordField) {
        this.$nextTick(() => {
          $('#reset-password-field').focus();
        });
      } else {
        this.sendConfirmationCode();
      }
    },
    showHidePassword(e) {
      const el = $(`#${e.target.id}`);
      el.toggleClass('fa-eye fa-eye-slash');
      const input = $(el.attr('toggle'));
      if (input.attr('type') === 'password') {
        input.attr('type', 'text');
      } else {
        input.attr('type', 'password');
      }
    },
    // #event
    sendConfirmationCode() {
      this.$emit('submit-code', this.verifyCode, this.password);
    },
    // #event
    requestNewVerifyCode() {
      this.$emit('request-new-code');
    },
    resetInput() {
      this.verifyCode = '';
      this.password = '';
      if (this.$refs.verificationCodeInput) {
        this.$refs.verificationCodeInput.reset();
      }
    },
    startTimer(lifetimeSeconds) {
      this.killTimer();
      this.stopTime = new Date();
      this.stopTime.setSeconds(this.stopTime.getSeconds() + Number(lifetimeSeconds));
      this.timer = setInterval(this.countdown, 1000);
      this.timerEnabled = true;
      this.timerText = `${this.downTimeMinute} : ${this.checkTime(this.downTimeSeconds)}`;
    },
    countdown() {
      const now = new Date().getTime();
      const distance = this.stopTime - now;
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.downTimeSeconds = seconds;
      this.downTimeMinute = minutes;

      if (distance <= 1) {
        this.killTimer();
        this.timerHasExpired = true;
      }

      this.timerText = `${this.downTimeMinute} : ${this.checkTime(this.downTimeSeconds)}`;
    },
    killTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.timerEnabled = false;
      this.timerHasExpired = false;
    },
  },
  created() {
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style scoped src='@/assets/css/authorization.css'>
</style>
